module.exports = __webpack_public_path__ + "img/benefit-icon_list.bf6544a4.svg";